const REVIEW_FALLBACK_MAX_LENGTH = 400;

type ReviewDisplaySource = {
  reviewSummary?: unknown;
  description?: unknown;
};

export function reviewDisplayText(review: ReviewDisplaySource): string {
  const summary = typeof review.reviewSummary === 'string' ? review.reviewSummary.trim() : '';
  if (summary) return summary;

  const description = typeof review.description === 'string' ? review.description.trim() : '';
  if (description.length <= REVIEW_FALLBACK_MAX_LENGTH) return description;
  return `${description.slice(0, REVIEW_FALLBACK_MAX_LENGTH).trimEnd()}…`;
}
